/**
 * Auto-generated from `MISSING_ANSWER_SENTINELS` in
 * apps/python-api/canonical_analysis/runtime.py.
 *
 * DO NOT EDIT - regenerate with (from apps/python-api):
 *   python -m scripts.export_reporting_missingness
 */
import { NOT_APPLICABLE_VALUE } from "../questionnaire/vocabularies";

/** Trimmed, lower-cased answer strings that mean no usable answer was given. */
export const MISSING_ANSWER_SENTINELS: ReadonlyArray<string> = [
  "",
  NOT_APPLICABLE_VALUE,
  "__not_applicable__",
  "n/a",
  "na",
  "none",
  "not_applicable",
]
